import ActionsForm from '@/shared/mixins/actionsForm'
import CountryRepository from '@/shared/http/repositories/geo/country.js'
import TravelReasonRepository from '@/shared/http/repositories/configuration/travelreason.js'
import CityRepository from '@/shared/http/repositories/geo/city'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import StateRepository from '@/shared/http/repositories/geo/state'
import AccessTermTravel from '@/shared/mixins/accessTermTravel'
import formData from '../InfoModalTravel/form-modal'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '../../../finance/expenses/travelrefund/mixins/ExpenseMixin.js'

export default {
  name: 'PanelTravelAdvance',
  mixins: [ExpenseMixin, ActionsForm, AccessTermTravel],
  components: {AutocompleteZ},
  data () {
    return {
      dataSituacao: [],
      form: formData(),
      dataCityFim: [],
      dataCityOrigem: [],
      pais: null,
      dataStateFim: [],
      dataState: [],
      dataTravel: [],
      editacao: null,
      dataCountry: [],
      colorSituacao: true,
      tipo: 0,
      dataTermo: [],
      DespesasemAdiantamento: false,
      solicitanteEdicao: false,
      nomeResponsavel: false,
      codigoResponsavel: false,
      BuscaCodigo: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      BuscaNome: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      }
    }
  },
  mounted () {
    this.getAllTravel()
    this.getAllAcces()
    this.getSituacao()
    this.getTermoId()
    this.getCountry()
  },
  watch: {
    Situacao (value) {
      console.log(value)
      this.tipo = 1
      this.getTermoId()
    },
    'BuscaCodigo.value': function (value) {
      if (value != null) {
        this.codigoResponsavel = true
        this.form.responsavelId.value = this.BuscaCodigo.value
      } else {
        this.codigoResponsavel = false
      }
    },
    'BuscaNome.value': function (value) {
      if (value != null) {
        this.nomeResponsavel = true
        this.form.responsavelId.value = this.BuscaNome.value
      } else {
        this.nomeResponsavel = false
      }
    }
  },
  filters: {
    formatDate (value) {
      let date = new Date(value)
      return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
    }
  },
  computed: {
    descricaoSituacao: function () {
      if (this.tipo === 1) {
        let situacao = this.dataTermo.situacao
        var texto = 'N/D'
        if (situacao === 0) {
          texto = 'AG RESPONSÁVEL OBRA'
        } else {
          texto = 'AG. ASSINATURA ANEXO'
        }
        if (situacao !== undefined) return texto
        return 'N/D'
      } else {
        this.changeColorSituacao(this.dataDetails.situacao)
        let situacao = this.dataSituacao.find((Element) => parseInt(Element.value) === this.dataDetails.situacao)
        if (situacao !== undefined) return situacao.text
        return 'N/D'
      }
    },
    isFired () {
      return this.dataDetails.favorecido.demissao ? 'result-info-red' : 'result-info'
    }
  },
  props: {
    comission: {
      type: Boolean,
      default: false
    },
    Situacao: {
      type: Boolean,
      default: false
    },
    dataDetails: {
      type: Object
    }
  },
  methods: {
    onChangeStateOrigem (e) {
      this.getCityOrigem(e)
    },
    editarSolitante () {
      this.solicitanteEdicao = !this.solicitanteEdicao
    },
    onChangeCountryFim (e) {
      this.getEstateFim(e)
    },
    EditarTermo () {
      loading.push()
      AcceptanceTermRepository.EditaTermoAceite({CidadeOrigemId: this.dataTermo.cidadeOrigemId, CidadeDestinoId: this.dataTermo.cidadeDestinoId, MotivoViagemId: this.dataTermo.motivoViagemId, DataInicio: this.dataTermo.inicio, DataFim: this.dataTermo.fim, TermoAceiteID: this.dataDetails.id, ResponsavelId: this.form.responsavelId.value})
        .then(Response => {
          this.editacao = Response.data
          toast.success('Adiantamento editado com sucesso!')
          this.getTermoId()
          this.solicitanteEdicao = false
          this.nomeResponsavel = false
          this.codigoResponsavel = false
          this.fecharPopUp()
          loading.pop()
          this.$emit('refreshLogAdvance')
          this.$refs['edita-viagem-term'].hide()
        })
        .catch(Error => {
          this.getTermoId()
          this.nomeResponsavel = false
          this.codigoResponsavel = false
          this.solicitanteEdicao = false
          if (Error.response.data != null) {
            toast.warning(Error.response.data)
          } else {
            toast.error('Erro')
          }
          this.$refs['edita-viagem-term'].hide()
          loading.pop()
        })
    },
    getAllTravel () {
      loading.push()
      TravelReasonRepository.GetAllByDesligado(true)
        .then(Response => {
          this.dataTravel = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    fecharPopUp () {
      this.form.estadoOrigemID.value = null
      this.form.cidadeOrigemId.value = null
      this.form.estadoDestinoID.value = null
      this.form.cidadeDestinoId.value = null
      this.form.dataInicio.value = null
      this.form.dataFim.value = null
      this.form.motivoViagemId.value = null
      this.$refs['edita-viagem-term'].hide()
    },
    getEstateFim (id) {
      loading.push()
      StateRepository.GetAllByCountryID(id)
        .then(Response => {
          this.dataStateFim = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getCityFim (id) {
      loading.push()
      CityRepository.GetAllByStateID(id)
        .then(Response => {
          this.dataCityFim = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getCountry () {
      CountryRepository.GetAll()
        .then(Response => {
          this.dataCountry = Response.data.data
          if (this.dataCountry.length <= 1) {
            this.pais = this.dataCountry[0].id
            this.getEstateFim(this.pais)
            this.form.paisDestinoID.value = this.dataCountry[0].id
            this.getEstate(this.pais)
          }
        })
        .catch(Error => console.log(Error))
    },
    onChangeCountryEnd (e) {
      this.getEstate(e)
    },
    onChangeStateFim (e) {
      this.getCityFim(e)
    },
    CityOrigem () {
      this.getCityOrigem(this.dataTermo.estadoOrigemId)
    },

    CityDestino () {
      this.getCityFim(this.dataTermo.estadoDestinoID)
    },
    editAdiantamento () {
      this.$refs['edita-viagem-term'].show()
    },
    changeColorSituacao (value) {
      if (this.tipo === 1) {
        if (parseInt(this.situacao) < 0 && parseInt(this.dataDetails.situacao) !== -4) {
          this.colorSituacao = false
        } else {
          this.colorSituacao = true
        }
      } else {
        if (parseInt(this.dataDetails.situacao) < 0 && parseInt(this.dataDetails.situacao) !== -4) {
          this.colorSituacao = false
        } else {
          this.colorSituacao = true
        }
      }
    },
    aprovar () {
      loading.push()
      AcceptanceTermRepository.NextStatus(this.dataDetails.id)
        .then(Response => {
          this.tipo = 0
          this.getTermoId()
          this.dataDetails.situacao = Response.data
          this.descricaoSituacao = this.dataDetails.situacao
          loading.pop()
          this.$emit('refreshLogAdvance')
          toast.success('Termo alterado com sucesso!!')
        })
        .catch(Error => {
          loading.pop()
          toast.error('Não foi possivel alterar o termo!!')
        })
    },
    reprovar () {
      loading.push()
      AcceptanceTermRepository.NextStatusDisaprove(this.dataDetails.id)
        .then(Response => {
          this.dataDetails.situacao = Response.data
          loading.pop()
          this.getTermoId()
          this.$emit('refreshLogAdvance')
          toast.success('Termo alterado com sucesso!!')
        })
        .catch(Error => {
          loading.pop()
          toast.error('Não foi possivel alterar o termo!!')
        })
    },
    getSituacao () {
      AcceptanceTermRepository.GetEnumSituacao()
        .then(Response => {
          this.dataSituacao = Response.data
        })
        .catch(Error => console.log(Error))
    },
    getTermoId () {
      console.log(this.dataDetails)
      AcceptanceTermRepository.TermoByid(this.dataDetails.id)
        .then(Response => {
          this.dataTermo = Response.data[0]
          if (Response.data[0].semAdiantamento === true) {
            this.DespesasemAdiantamento = !this.DespesasemAdiantamento
          }
          this.CityOrigem()
          this.CityDestino()
          // this.descricaoSituacao = this.dataTermo
          // this.dataTermo = Response.data
          // this.DespesasemAdiantamento = Response.data.semAdiantamento
          // this.dataTermo = Response.data.data
          // this.DespesasemAdiantamento = Response.data.data.semAdiantamento
        })
        .catch(Error => console.log(Error))
    },
    getCityOrigem (id) {
      loading.push()
      CityRepository.GetAllByStateID(id)
        .then(Response => {
          this.dataCityOrigem = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    excluirTerm () {
      loading.push()
      AcceptanceTermRepository.ExcluirAdiantamentoViagem(this.CompanySelected, this.dataDetails.id)
        .then(Response => {
          loading.pop()
          if (Response.data && Response.data.code === 200) {
            toast.success('Adiantamento excluído com sucesso!')
            window.location.reload()
          } else {
            toast.error((Response.data && Response.data.message) || 'Não foi possível excluir o adiantamento')
          }
        })
        .catch(Error => {
          loading.pop()
          toast.error('Não foi possível excluir o adiantamento')
        })
    },
    changeText () {
      this.isFired = !this.isFired
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/PanelTravelAdvance/PanelTravelAdvance.js